import { api } from './api';

export async function getTutorialById(id: string) {
  const payload = [{ $match: { _id: id } }];

  try {
    const { data } = await api.post('find/get_tutorial', {id});
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (error) {
    return error;
  }
}


export async function getHelp() {
  const payload = {};

  try {
    const { data } = await api.post('find/help', payload);
    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (error) {
    return error;
  }
}
